import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  width: 400px;
  padding-bottom: 40px;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  position: relative;

  border-radius: 16px;
  background: var(--alias-color-background-normal-normal);
`;

export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  padding: 20px 24px;

  border-bottom: 2px solid var(--alias-color-line-normal);
`;

export const Section = styled.div`
  display: flex;
  padding: 0px 48px;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  align-self: stretch;
`;

export const Options = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
`;

export const OptionItem = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`;

export const Btns = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
`;

export const CancelBtn = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;

  cursor: pointer;
`;
